export default __webpack_public_path__ + "static/media/top100-logo-p.99f3ae46.png";